const actionTypes = {
  PopularsFetched: 'POPULARS_FETCHED',
  FetchStores: 'FETCH_STORES',
  FetchOrderSetups: 'FETCH_ORDER_SETUPS',
  FetchSuburbs: 'FETCH_SUBURBS',
};

export default actionTypes;
